import './ValueChange.scss'
import DirectionIcon from "./icons/DirectionIcon.jsx";
import Counter from "./Counter.jsx";
import {DECIMAL_FORMAT} from "../../util/numbers.js";
import {getDirectionColorClassName} from "../../util/misc.js";
import GasIcon from "mdi-react/GasIcon.js";

export default ({
                    valueFrom,
                    valueTo,
                    isReductionPositive = false,
                    isBurn = false,
                    isDividend = false,
}) => {
    const valueDelta = Math.abs(valueTo) - Math.abs(valueFrom)
    const directionalMultiplier = isReductionPositive ? -1 : 1
    const valueDeltaRelative = valueDelta / valueFrom * 100
    return (
        <div className='value-change flex-vertical-center'>
            {isBurn ?
                <GasIcon className='direction-icon is-gas'/>
                :
                <DirectionIcon value={valueDelta * directionalMultiplier} isGolden={isDividend}/>
            }
            <Counter
                amount={valueDelta}
                absolute={true}
            />
            {!isBurn && !isDividend &&
            <Counter
                amount={valueDeltaRelative}
                className={`secondary ${getDirectionColorClassName(valueDelta * directionalMultiplier)}`}
                suffix={'%'}
                absolute={true}
                decimals={DECIMAL_FORMAT.FLEX_PERCENTAGE}
            />
            }
        </div>
    )
}